import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {GoalVisibility} from "../models/goal/goal-visibility.model";
import {environment} from "../../../environments/environment";

const GOAL_VISIBILITY_ROOT_URL: string = environment.backendCoreURL + "/goal-visibilities";

@Injectable()
export class GoalVisibilityService {

    constructor(private http: HttpClient) {
    }

    getGoalVisibilityList(): Observable<GoalVisibility[]> {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf8'});

        return this.http.get<GoalVisibility[]>(GOAL_VISIBILITY_ROOT_URL, {headers: headers});
    }
}